import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";

import { getDetalleSolicitudEmision, clearData } from "./actions";
import { paths, solicitudesEmisionPath } from "~constants/referenceNames";
import Documentacion from "./Documentacion";
import Historia from "./Historia";
import DetalleSolicitudHistorica from "./DetalleSolicitudHistorica";
import DetailsLayout from "~styled/layouts/detailsLayout/DetailsLayout";
import DetailsTabs from "~styled/layouts/detailsLayout/DetailsTabs";
import { estadosSolicitudEmisionOptions } from "../listado/filtros/estados";
import { GetSolicitudEmisionResponse } from "~api/types";

interface SliceDetalleSolicitudHistorica {
  detalleSolicitudEmision: GetSolicitudEmisionResponse | null;
  errorMessage?: string;
}

const useReduxSelector = () =>
  useSelector<any, SliceDetalleSolicitudHistorica>((state) => ({
    detalleSolicitudEmision:
      state.detalleSolicitudHistoricaReducer.detalleSolicitudEmision,
    errorMessage: state.detalleSolicitudHistoricaReducer.errorMessage,
  }));

const DetalleSolicitudHistoricaContainer: React.FC = () => {
  const { detalleSolicitudEmision } = useReduxSelector();
  const { id } = useParams<{ id: string }>();
  const dispatch = useDispatch();
  const history = useHistory();
  const [currentTab, setCurrentTab] = useState(0);

  useEffect(() => {
    dispatch(getDetalleSolicitudEmision(id) as any);

    return () => {
      dispatch(clearData());
    };
  }, [dispatch, id]);

  const backAction = () => {
    history.push(paths[solicitudesEmisionPath]);
  };

  return (
    <DetailsLayout
      title={"Detalle de la Solicitud"}
      backAction={backAction}
      subtitle={
        detalleSolicitudEmision
          ? estadosSolicitudEmisionOptions[detalleSolicitudEmision.estado]
          : null
      }
      tabsComponent={() => (
        <DetailsTabs
          defaultValue={0}
          labels={[
            <TabIndex text="DETALLE" />,
            <TabIndex text="DOCUMENTACIÓN" />,
            <TabIndex text="HISTORIA" />,
          ]}
          onChange={(e) => {
            setCurrentTab(e.target.value);
          }}
        />
      )}
    >
      {currentTab === 0 && <DetalleSolicitudHistorica />}
      {currentTab === 1 && <Documentacion />}
      {currentTab === 2 && <Historia />}
    </DetailsLayout>
  );
};

const TabIndex: React.FC<{ text: string }> = ({ text }) => {
  return (
    <>
      <span style={{ display: "flex", alignItems: "center" }}>{text}</span>
    </>
  );
};

export default DetalleSolicitudHistoricaContainer;
